<script lang="ts">
  import { Loader } from '@shared/ui/loader';
  import { is } from '@shared/utils';

  export let isLoading = false;
  export let isDisabled = false;
  export let classes = '';
</script>

<button
  disabled="{isDisabled || isLoading}"
  type="button"
  class="bg-rainbow rounded-lg font-medium {is(
    isLoading,
    'bg-rainbow-animated',
  )} flex w-full flex-wrap items-center justify-center gap-2 border border-transparent px-4 py-3 {classes}"
>
  <slot />

  {#if isLoading}
    <Loader />
  {/if}
</button>

<style lang="scss">
  .bg-rainbow {
    background: linear-gradient(90deg, #bfaeff, #b7e2e8, #d2ff9b, #fffcaf, #ffffff);
    background-size: 400% 400%;
    color: black;

    &-animated {
      animation: gradientBG 4.5s ease infinite;
    }
  }
  @keyframes gradientBG {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
</style>
